import { Context, createElement, useContext } from 'react';

import { ApiContext, GlobalApiContext } from './contexts';

export const useApi = <T>() =>
  useContext<T>(ApiContext as unknown as Context<T>);

export const useGlobalApi = <T>() =>
  useContext<T>(GlobalApiContext as unknown as Context<T>);

export const ApiProvider = ({ context = ApiContext, value, children }) =>
  createElement(context.Provider, { value }, children);
